import currentVideoSaga from 'store/modules/currentVideo/sagas'
import globalDataSaga from 'store/modules/globalPlayerData/sagas'

export default [currentVideoSaga, globalDataSaga]
